<template>
  <div class="modal-body">
    <div class="info-row">
      <div class="info-item">
        <span class="label">异常类型：</span>
        <span class="value">{{ exceptionInfo.exceptionTypeName || '--' }}</span>
      </div>
      <div class="info-item">
        <span class="label">预计发货时间：</span>
        <span class="value">{{ time || '--' }}</span>
      </div>
      <div class="info-item">
        <span class="label">原因：</span>
        <span class="value">{{ remark || '--' }}</span>
      </div>
    </div>
    <div class="replace-list">
      <div class="replace-title">
        可替换药品
        <span class="tips">若患者紧急，可考虑替换方案</span>
      </div>
      <div class="replace-items">
        <!-- 原药品 -->
        <div class="replace-item" v-for="(drug, index) in replaceableDrugs" :key="index">
          <div class="orig-box">
            <a-image :width="50" :height="50" :src="drug.originSkuImageUrl" />
            <div class="name name-replace">{{ drug.originSkuName }}</div>
          </div>
          <!-- 替换图标 -->
          <div class="icon">
            <a-image :src="replaceIcon" />
          </div>
          <!-- 替换药品 -->
          <div class="orig-box replace-box">
            <a-image :width="50" :height="50" :src="drug.replaceableSkuImageUrl" />
            <div class="name">{{ drug.replaceableSkuName }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import replaceIcon from '@/assets/img/replace-icon.png'
const props = defineProps({
  detail: { type: Object, default: () => {} }
})
const exceptionInfo = computed(() => props.detail.exceptionInfo || {})
const replaceableDrugs = computed(() => props.detail.replaceableDrugs || [])
const time = computed(() =>
  exceptionInfo.value.deliveryTimeType === 1
    ? exceptionInfo.value.deliveryTime
    : exceptionInfo.value.deliveryTimeTypeName
)
const remark = computed(
  () => `${exceptionInfo.value.reasonName}。${exceptionInfo.value?.reasonRemark || ''}`
)
</script>

<style scoped lang="scss">
.modal-body {
  .info-row {
    padding-bottom: 32px;
    border-bottom: 1px solid #eee;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    .info-item {
      display: flex;
      align-items: center;
      margin-bottom: 32px;
      &:last-child {
        margin-bottom: 0;
      }
      .label {
        font-weight: 500;
        margin-right: 16px;
        color: #999;
      }
      .value {
        color: #333;
      }
    }
  }
  .replace-list {
    margin-top: 20px;
    .replace-title {
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      margin-bottom: 16px;
      .tips {
        font-size: 12px;
        color: #999;
        margin-left: 8px;
        font-weight: 400;
      }
    }
    .replace-items {
      .replace-item {
        display: flex;
        align-items: center;
        position: relative;
        margin-bottom: 12px;
        .orig-box {
          display: flex;
          align-items: center;
          width: 50%;
          border-radius: 4px;
          background: #fcf7f1;
          border: 1px solid #f9e5d9;
          padding: 12px 24px 12px 16px;
          margin-right: 12px;
          ::v-deep(.ant-image) {
            overflow: hidden;
            border-radius: 4px;
          }
          .name {
            margin-left: 8px;
            font-weight: 500;
            font-size: 16px;
            color: #333333;
          }
          .name-replace {
            color: #f84b1c;
          }
        }
        .replace-box {
          background: #f5f5f5;
          border: none;
        }
        .icon {
          position: absolute;
          width: 48px;
          height: 28px;
          left: calc(50% - 32px);
        }
      }
    }
  }
}
</style>
